import cn from 'classnames';

export const dropContainerClassName = ({
  isOpen,
  // dropTop = false,
  vladSpecialProp = false,
}: {
  isOpen: boolean;
  dropTop: boolean;
  vladSpecialProp: boolean;
}) =>
  cn(
    isOpen ? 'transition visible ease-in-out' : `${vladSpecialProp ? 'hidden' : 'invisible'}`,

    'duration-[80]',
    'shadow-popover',
    'bg-white',
    'py-[8px]',
    'z-[9999]',
    'rounded-defaultR',
  );

export const dropTriangleClassName = (position: string, dropTop) =>
  cn(
    'inline-flex',
    position,
    'w-full',
    'left-0',
    'absolute',
    // dropTop ? '' : '',
    dropTop ? 'top-full bottom-[-20px]' : 'top-[-20px]',
  );

export const dropListItemClassName = cn(
  'rounded-defaultR',
  'font-[500]',
  'text-[13px]',
  'px-[10px]',
  'w-full',
  'rounded-[10px]',
  'list-none',
);
export const dropItemWrapperClassName = (
  isActive = false,
  color: string,
  isNotDanger: boolean,
  disable: boolean,
) =>
  cn(
    isActive && 'bg-pastel_action',
    disable && 'opacity-[0.5]',
    color,
    'truncate',
    !disable && isNotDanger && ' hover:text-speech_analitics',
    'inline-flex',
    'rounded-defaultR',
    !disable && 'cursor-pointer',
    'px-[12px]',
    'py-[8px]',
    'pb-[7px]',
    'h-full',
    'w-full',
    'items-center',
    !disable && 'hover:bg-defaultBg',
  );
